import api from './client'

export async function downloadFile(path: string, filename: string): Promise<void> {
  const response = await api.get(path, { responseType: 'blob' })
  const url = URL.createObjectURL(response.data as Blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export function downloadTransactionsCsv(): Promise<void> {
  return downloadFile('/export/transactions.csv', 'transactions.csv')
}

export function downloadAccountsCsv(): Promise<void> {
  return downloadFile('/export/accounts.csv', 'accounts.csv')
}

export function downloadGoalsCsv(): Promise<void> {
  return downloadFile('/export/goals.csv', 'goals.csv')
}

export function downloadFullExport(): Promise<void> {
  return downloadFile('/export/full', 'logmyspends-export.json')
}
